import React, { useEffect } from "react";
import { Stack, TextField, Typography, useTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { styled, SxProps } from "@mui/material";
import ImageAssets from "../../../assets";
import { InputStyles, StyledStaticDatePicker } from "./MuiDatepicker.style";
import theme from "../../../mui-themes/SekeronTheme";
import dayjs, { Dayjs } from "dayjs";
import Badge from "@mui/material/Badge";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { CalendarPickerSkeleton } from "@mui/x-date-pickers/CalendarPickerSkeleton";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
interface IMuiDatePickerProps {
  name: string;
  maxdate?: any;
  label: string;
  inputformat: string;
  value: any;
  onChange: (newValue: any) => void;
  mindate?: any;
  onBlur?: any;
  disablefuture?: string;
  formik?: any;
  inputProps?: any;
  isFormikDropDown?: boolean;
  errorMessage?: string;
  onOpen?: (newValue: any) => void;
  component?: string;
}
interface IItem {
  sekeronTheme: any;
}

const Item = styled("div") <IItem>`
  margin-top: 0px !important;
  padding: ${({ sekeronTheme }) => sekeronTheme.spacing(0.5)};
  text-align: "center";
`;
const Wrapper = styled("div") <any>`
  @media (min-width: 320px) and (max-width: 376px) {
    .error-message-container {
      position: relative !important;
    }
  }
`;
const popperSx: SxProps = {
  "& .MuiPickersPopper-root ": {
    // position: 'absolute',
    // inset: 'auto auto 0px 25px'
  },
  "& .MuiPaper-root": {
    borderRadius: "11.6px",
    backgroundColor: "red",
    backgroundImage: "linear-gradient(316deg, #2ebbaf, #3e6be3)",
    fontFamily: "Comfortaa-Regular",
  },
  "& .MuiPickersDay-root ": {
    color: "#d7d7d7",
    background: "transparent",
    fontFamily: "Comfortaa-Regular",
    fontSize: "1.59rem",
  },
  "& .MuiTypography-root ": {
    color: theme.palette.common.white,
    textAlign: "center",
    background: "transparent",
    fontFamily: "Comfortaa-Regualar",
    fontSize: "1.6rem",
  },
  "& .MuiSvgIcon-root": {
    color: theme.palette.common.white,
    fontSize: "2rem",
    "@media (min-width:320px)  and (max-width:840px)": {
      fontSize: "1.6rem",
    },
  },
  "& .MuiInputAdornment-root ": {
    color: "white",
    fontSize: "4.6rem !important",
    "&&& .MuiButtonBase-root": {
      ".MuiSvgIcon- root": {
        fontSize: "8rem",
      },
    },
  },
  "& .MuiPickersCalendarHeader-root  ": {
    color: theme.palette.common.white,
    textAlign: "center",
    background: "transparent",
    fontFamily: "Comfortaa-Regular ",
    fontSize: "2.6rem",
    fontWeight: "bold",
    "& .MuiPickersCalendarHeader-label ": {
      color: theme.palette.common.white,
      textAlign: "center",
      background: "transparent",
      fontFamily: "Comfortaa-Regular ",
      fontSize: "1.8rem",
    },
  },
  "& .PrivatePickersYear-yearButton ": {
    color: theme.palette.common.white,
    textAlign: "center",
    background: "transparent",
    fontSize: "2rem",
    fontFamily: "Comfortaa-Regular",
  },
  "& .MuiCalendarPicker-root ": {
    backgroundImage: "linear-gradient(281deg, #4fd8cc, #5c88ff)",
    fontFamily: "Comfortaa-Regular ",
    borderRadius: "16px",
  },
};

const MuiDatepicker = (props: any) => {
  const theme = useTheme();
  const { maxdate, inputformat, mindate, value, errorMessage, component } = props;
  return (
    <InputStyles
      error={!value && errorMessage !== ""}
      theme={theme}
      value={value}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3}>
          <DesktopDatePicker
            {...props}
            value={value}
            onChange={props.onChange}
            onOpen={props.onOpen}
            // onBlur={props.onBlur}
            inputFormat={inputformat}
            maxDate={maxdate ? maxdate : null}
            minDate={mindate}
            // disableFuture={disablefuture == 'true' ? true : false}
            renderInput={(params: any) => {
              return <TextField {...params} size="medium" autoComplete="off" />;
            }}
            components={{
              OpenPickerIcon: CalendarMonthIcon,
            }}
            PopperProps={{
              sx: popperSx,
            }}
          />
        </Stack>
      </LocalizationProvider>
      <Wrapper>
        {!value && errorMessage !== "" ? (
          <Stack
            className="error-message-container"
            flexDirection={"row"}
            alignItems={"center"}
            spacing={0.5}
            sx={{ background: "none" }}
          >
            <Item sekeronTheme={theme}>
              <img src={ImageAssets.ic_error_info} alt="" />
            </Item>
            <Item sekeronTheme={theme}>
              <Typography className="input-error">{errorMessage}</Typography>
            </Item>
          </Stack>
        ) : (
          <div
            style={component && component === "registrationV1" ? {} : { visibility: "hidden", height: "27px" }}
          ></div>
        )}
      </Wrapper>
    </InputStyles>
  );
};

const MuiDateTimepicker = (props: any) => {
  const theme = useTheme();
  const { maxdate, inputformat, mindate, value, errorMessage } = props;
  return (
    <InputStyles
      error={!value && errorMessage !== ""}
      theme={theme}
      value={value}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack>
          <DateTimePicker
            {...props}
            value={value}
            onChange={props.onChange}
            // onBlur={props.onBlur}
            inputFormat={inputformat}
            maxDate={maxdate ? maxdate : null}
            minDate={mindate}
            // disableFuture={disablefuture == 'true' ? true : false}
            renderInput={(params: any) => {
              return <TextField {...params} size="medium" autoComplete="off" />;
            }}
            components={{
              OpenPickerIcon: CalendarMonthIcon,
            }}
            PopperProps={{
              sx: popperSx,
            }}
          />
        </Stack>
      </LocalizationProvider>
      <Wrapper>
        {!value && errorMessage !== "" ? (
          <Stack
            className="error-message-container"
            flexDirection={"row"}
            alignItems={"center"}
            spacing={0.5}
            sx={{ background: "none" }}
          >
            <Item sekeronTheme={theme}>
              <img src={ImageAssets.ic_error_info} alt="" />
            </Item>
            <Item sekeronTheme={theme}>
              <Typography className="input-error">{errorMessage}</Typography>
            </Item>
          </Stack>
        ) : (
          <div
          // style={{ visibility: "hidden", height: "27px" }}
          ></div>
        )}
      </Wrapper>
    </InputStyles>
  );
};

const MuiStaticDatePicker = ({ meetingsDate, setSelectedDate }) => {
  const initialValue = dayjs(new Date());
  const requestAbortController = React.useRef<AbortController | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [highlightedDays, setHighlightedDays] = React.useState<number[]>([]);
  const [value, setValue] = React.useState<Dayjs | null>(initialValue);

  const updateHighlightedDays = (date: Dayjs) => {
    const filteredDays = meetingsDate
      .map((meetingDate) => dayjs(meetingDate))
      .filter(
        (meetingDate) =>
          meetingDate.month() === date.month() &&
          meetingDate.year() === date.year()
      )
      .map((meetingDate) => meetingDate.date());

    setHighlightedDays(filteredDays);
  };

  // Initial setup of highlighted days for the initial month
  useEffect(() => {
    if (meetingsDate?.length > 0) {
      updateHighlightedDays(value);
    }
  }, [meetingsDate, value]);

  // Handle month change to update highlighted days
  const handleMonthChange = (date: Dayjs) => {
    setIsLoading(true);
    updateHighlightedDays(date);
    setIsLoading(false);
  };

  const handleOnChange = (value: any) => {
    setValue(value);
    setSelectedDate(new Date(value));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledStaticDatePicker>
        <StaticDatePicker
          value={value}
          loading={isLoading}
          displayStaticWrapperAs="desktop"
          onChange={(newValue) => handleOnChange(newValue)}
          onMonthChange={handleMonthChange}
          renderInput={(params: any) => <TextField {...params} />}
          renderLoading={() => <CalendarPickerSkeleton />}
          renderDay={(day: any, _value: any, DayComponentProps: any) => {
            const isSelected =
              !DayComponentProps.outsideCurrentMonth &&
              highlightedDays.includes(day.date());

            return (
              <Badge
                variant="dot"
                invisible={!isSelected}
                key={day.toString()}
                overlap="circular"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: theme.palette.common.white,
                  },
                }}
              >
                <PickersDay {...DayComponentProps} />
              </Badge>
            );
          }}
        />
      </StyledStaticDatePicker>
    </LocalizationProvider>
  );
};

export default MuiStaticDatePicker;

export { MuiDatepicker, MuiStaticDatePicker, MuiDateTimepicker };
